import { type StoreActionApi } from 'react-sweet-state';

import type { ChatMessageResearchStore } from './types';

type CompleteAllStepsArgs = { messageId: string };

type ChatMessageResearchStoreAction = (api: StoreActionApi<ChatMessageResearchStore>) => void;

export const completeAllSteps: (args: CompleteAllStepsArgs) => ChatMessageResearchStoreAction =
	({ messageId }: { messageId: string }) =>
	({ getState, setState }: StoreActionApi<ChatMessageResearchStore>) => {
		const currentState = getState();
		const message = currentState[messageId];
		if (message && !message.researchCompleted) {
			const updatedSteps = Object.entries(message.steps).reduce(
				(acc, [stepId, step]) => ({
					...acc,
					[stepId]: {
						...step,
						completed: true,
					},
				}),
				{},
			);

			setState({
				...currentState,
				[messageId]: {
					...message,
					steps: updatedSteps,
					currentProgress: undefined,
					researchCompleted: true,
				},
			});
		}
	};
